const LogActionButton = ({onClick, children}) => (
    <div
        className='text-xs flex-1 cursor-pointer rounded-md bg-gray-100 px-2 py-1.5 text-center font-medium text-color-primary transition-colors active:bg-gray-200'
        onClick={onClick}
    >
        {children}
    </div>
);

export default LogActionButton;
